import styled from 'styled-components';

type ErrorWrapperProps = {
  size?: number;
  color?: string;
  marginTop?: number;
  marginRight?: number;
};

export const ErrorWrapper = styled.div<ErrorWrapperProps>`
  font-size: ${(props) => props.size ?? props.theme.typography.fontSize}px;
  color: ${(props) => props.color ?? props.theme.palette.darkRed};
  text-align: center;
  margin-top: ${(props) => props.marginTop ?? 0}px;
  margin-right: ${(props) => props.marginRight ?? 0}px;
  padding: 0 !important;
`;
